import { OperationStatus } from '@evidentid/vue-commons/store/OperationStatus';

import { defaultFeatureFlags } from '@/services/getSessionInterview';

import IdoState, { Status } from './interfaces/IdoState';

export default function buildInitialState(): IdoState {
    return {
        status: Status.uninitialized,
        consentGiven: false,
        error: null,
        snackbar: {
            success: false,
            permanent: false,
            message: null,
        },
        requestStatus: null,
        gls: null,
        session: null,
        user: null,
        issuer: null,
        balance: null,
        questions: [],
        summary: null,
        submission: {},
        values: {},
        academicProviders: null,
        utilityProviders: null,
        criminalOffenses: null,
        delegationsRequested: {},
        verificationsRequested: {},
        featureFlags: { ...defaultFeatureFlags },
        stripe: null,
        glsResendLinkStatus: {},
        onlineChat: { loadAgentResponse: OperationStatus.uninitialized },
        attributeSharingAgreements: null,
    };
}
